<template>
  <modal
    name="toAppTemplateRemind"
    transition="nice-modal-fade"
    :pivotY="0.3"
    @before-open="tipOpen"
    width="540"
    height="264"
  >
    <div class="dialog">
      <div class="title">
        <!-- <span>提示</span> -->
        <div class="close-button" @click="close">
          <i></i>
        </div>
      </div>
      <div class="content">
        <span>
          执行导出App模板操作将直接清除两端不兼容的素材，并将不支持的样式以及动画属性重置为对应的默认值。
          导出模板完成后将直接修改项目的数据，且仅支持发布模板到App平台。请确认！
        </span>
      </div>
      <div class="button-content">
        <div class="close" @click="close">取消</div>
        <div class="sure" @click="sure">确认</div>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: "toAppTemplateRemind",
  data() {
    return {
      params: ""
    };
  },
  props: {},
  components: {},
  methods: {
    tipOpen(e) {
      this.params = e.params.data;
    },
    close() {
      this.$modal.hide("toAppTemplateRemind");
    },
    sure() {
      this.$store.commit("save_TopnavMsg", {
        isShowExportDialog: true,
        isShowSavingMask: true,
        transferData: { type: "template", platform: 2 },
        savingMaskText: "正在生成封面数据中..."
      });
      this.$modal.hide("toAppTemplateRemind");
    }
  },
  watch: {},
  computed: {}
};
</script>

<style scoped lang="scss">
.dialog {
  position: relative;
  width: 540px;
  height: 264px;
  background: #fff;
  border-radius: 3px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;

  .close-button {
    position: absolute;
    right: 17px;
    top: 17px;
    width: 12px;
    cursor: pointer;
    > i {
      position: relative;
      //   left: 7px;
      //   top: 5px;
      width: 2px;
      height: 15px;
      border-radius: 3px;
      background: #737596;
      transform: rotate(45deg);
      display: inline-block;
      &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 2px;
        height: 15px;
        border-radius: 3px;
        background: #737596;
        transform: rotate(270deg);
      }
    }
  }
  .title {
    height: 45px;
  }
  .content {
    //margin: 0 auto;
    width: 364px;
    font-size: 14px;
    color: #333333;
    text-align: center;
    line-height: 30px;
  }
  .button-content {
    margin-top: 20px;
    width: 364px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .close,
    .sure {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      width: 160px;
      height: 40px;
      border-radius: 4px;
      cursor: pointer;
    }
    .close {
      color: #333333;
      background-color: #eaeaf6;
    }
    .sure {
      color: #fefefe;
      background-color: #5778fb;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/topnav/toAppTemplateRemind.vue